import React, { Component } from "react";
// import Wrp from '../../../../../../../hoc/Wrp/Wrp';
// import {Card,CardBody} from '../../../../../../../hoc/Card';
import BootstrapRow from '../../../../../../../hoc/BootstrapRow';
import BootstrapColumn from '../../../../../../../hoc/BootstrapColumn';
// import Datetime from 'react-datetime';
import moment from 'moment';
import 'react-datetime/css/react-datetime.css';
// import {getDateFormat} from '../../../../../../../../Utils/UserFunctions';
import RepeatEveryWithOption from './RepeatEvery';
class Repeat extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dt: moment(),
      setDt: moment(),
      isReminderPopup:false,
      isReminderSelected:false,
      reminderJsonTemp:this.props.reminderJson
    }
  }
  // cancelRepeatPopup = (e)=>{
  //   const  {
  //     popupModeChangeHandler,
  //     updateReminderComponentObject
  //   } = this.props;
  //   updateReminderComponentObject(this.state.reminderJsonTemp);
  //   popupModeChangeHandler('REMINDER');
  // }
  render() {
    // const  {
    //   reminderJson,
    //   applyRepeatHandler,
    //   attr,
    //   repeatApplyButton
    // } = this.props;
    
    //repeat_ends
    return (
          <BootstrapRow>
            <BootstrapColumn column={`col-12`}>
              <RepeatEveryWithOption
                {...this.props}
                 />
            </BootstrapColumn>
          </BootstrapRow>
       
    );
    
  }
  
}

Repeat.defaultProps = {
}

export default Repeat;
